import { Card as HeroUICard, CardProps as HeroUICardProps } from "@heroui/react";

interface CardProps extends HeroUICardProps {
    scaleOnHover?: boolean
}

const Card: React.FC<CardProps> = ({ children, ...props }) => {

    return (
        <HeroUICard {...props} shadow="sm" className={`custom-card ${props.className ? props.className : ""} ${props.scaleOnHover && props.isHoverable ? "scale-on-hover" : ""}`}  >
            {children}
        </HeroUICard >
    )
}

export default Card